import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import _ from 'lodash';
import { updateTabSetting } from '../../../actions/apiDealerUpdates';

const IconButton = ({ onClick, icon, tab }) => (
    <button onClick={onClick} name={`fas fa-${icon}`} data-icon={`fas fa-${icon}`} data-id={tab.id} className={'btn btn-clear btn-lg'}>
        <i onClick={onClick}className={`fas fa-${icon}`} />
    </button>
);

const IconPickerPopup = (props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [key, setKey] = useState(props.value); // Use props.value as key for re-render

    const dispatch = useDispatch();
    const all_tabs = useSelector(state => state.settings_site.all_tabs);
    const edit_tab = useSelector(state => state.settings_site.all_tabs) || props.edit_tab;

    useEffect(() => {
        // This will reset the key to force re-render when props.value changes
        setKey(props.value);
    }, [props.value]); // Dependency array includes props.value

    const getTabByName = () => {
        const value = _.sortBy(_.filter(all_tabs, o => o.name === edit_tab), 'id');
        return value[0];
    };

    const onClickIcon = (e) => {
        e.stopPropagation(); // Stop the event from propagating further
        const button = e.target.closest('button');
        const { id } = button.dataset;
        const data = {
            id,
            [props.name]: button.name,
        };
        dispatch(updateTabSetting(id, data, 'editTabSetting'));
        closeModal();
    };
    

    const openModal = () => setModalIsOpen(true);
    const closeModal = () => setModalIsOpen(false);

    const getIconList = () => ({
        solid: ['far fa-paperclip', 'far fa-clock', 'far fa-alarm-clock', 'far fa-cogs', 'far fa-usd-square', 'far fa-dollar-sign',
                'far fa-camera-retro', 'far fa-camera-alt', 'far fa-clipboard-list', 'far fa-car', 'far fa-clipboard-check',
                'far fa-tasks', 'far fa-usd-square', 'far fa-chart-bar', 'far fa-ellipsis-h-alt', 'far fa-receipt',
                'far fa-calendar-plus', 'far fa-check-circle'],
    });

    const iconList = useMemo(() => getIconList(), []); // Memoize icon list if it's static
    const tab = useMemo(() => getTabByName(), [edit_tab, all_tabs]); // Memoize tab lookup

    const defaultStyle = {
        background: props.bg_color,
        backgroundColor: props.bg_color,
        color: props.font_color,
    };

    return (
        <span key={key}>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Select Icon"
                className="d-flex justify-content-center"
                ariaHideApp={false}
                overlayClassName="overlay"
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Select Icon</h4>
                        <button type="button" className="close" onClick={closeModal}>&times;</button>
                    </div>
                    <div className="modal-body">
                        <div className="icon-grid">
                            {iconList.solid.map(icon => (
                                <IconButton key={`icon_${icon}`} onClick={onClickIcon} icon={icon} tab={tab} />
                            ))}
                        </div>
                    </div>
                </div>
            </Modal>
            <button className={'btn btn-sm btn-clear'} style={defaultStyle} onClick={openModal}>
                <i className={props.value} />
            </button>
        </span>
    );
};

export default IconPickerPopup;
